import React from 'react';
import { browserHistory } from 'react-router';
import Breadcrumb from '../../../core/layout/Breadcrumb';
import Card from '../../../core/layout/Card';
import Button from '../../../core/form/Button';
import VocabularyListFilterContainer from './VocabularyListFilterContainer';
import VocabularyListContainer from './VocabularyListContainer';

const VocabularyListScene = () => (
  <div>
    <Breadcrumb
      crumbs={[
        {
          text: 'Vocabularies',
        },
      ]}
    />
    <Card
      title="Vocabularies"
      actions={
        <Button
          type="primary"
          label="New vocabulary"
          icon="plus"
          onClick={() => browserHistory.push('/vocabularies/new')}
        />
      }
    >
      <VocabularyListFilterContainer />
      <VocabularyListContainer />
    </Card>
  </div>
);

export default VocabularyListScene;
